import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';

export const sentrySetup = (app: App, router: Router) => {
  const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;
  const APP_ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT as string;

  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: APP_ENVIRONMENT,
    integrations: [
      new BrowserTracing({
        tracingOrigins: ['https://dev.tbs-ch.com/', 'https://stg.tbs-ch.com/', 'https://tbs-ch.com/'],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Integrations.TryCatch({
        eventTarget: false,
      }),
    ],
    enabled: APP_ENVIRONMENT !== 'local',
    // NOTE: Transaction上限を確認しながら設定する
    tracesSampleRate: import.meta.env.MODE === 'prod' ? 0.05 : 0.02,
    beforeSend(event, hint) {
      if (event.exception) {
        console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint });
      }
      return event;
    },
    ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'],
  });

  app.mixin(
    Sentry.createTracingMixins({
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'mount', 'update'],
    })
  );
  Sentry.attachErrorHandler(app, {
    logErrors: false,
    attachProps: true,
    trackComponents: true,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update'],
  });
};
